import type { ShoppingDistrictSpec } from "./shoppingDistrict";

/**
 * Hillcrest (world v5, ADR-0041 decision 3): west of Central (x -632..-312), the mirror image of Riverside. World v6
 * (ADR-0042): Market Street runs on west into High Street at the old wall line (x = -312), so Hillcrest is reached on
 * foot or by car along the road. High Street with shops c-84..c-103 (north row west to east, then the south row), Rowan
 * Lane (nearer Central, r-61..r-70) and Laurel Lane (r-71..r-80), Quarry Road behind them; billboards bb-7 (the square)
 * and bb-8 (the far end of High Street).
 */
export const HILLCREST: ShoppingDistrictSpec = {
  id: "hillcrest",
  name: "Hillcrest",
  side: -1,
  streetName: "High Street",
  laneNames: ["Rowan Lane", "Laurel Lane"],
  backRoadName: "Quarry Road",
  firstShop: 84,
  firstPlot: 61,
  billboardIds: ["bb-7", "bb-8"],
  northStyles: ["modern_midrise", "corner_shop", "landmark_tower", "small_shop", "office_block", "colorful_tower", "corner_shop", "small_shop", "modern_midrise", "office_block"],
  southStyles: ["small_shop", "office_block", "colorful_tower", "modern_midrise", "corner_shop", "landmark_tower", "office_block", "small_shop", "colorful_tower", "corner_shop"],
};
